import React, {Component} from 'react';
import axios from "axios";
import '../spinner.css'
import {loadStripe} from "@stripe/stripe-js";

export class AppWebView extends Component {
    static displayName = AppWebView.name;
c
    constructor(props) {
        super(props);
        this.state = {
            error: false
        };
    }

    async componentDidMount() {
        const {businessId, temporaryToken, priceId, cancelUrl} = this.props;
        let result = await this.getStripeMember(businessId, temporaryToken, priceId, cancelUrl);
        if (result.data.isBillingPortal) {
            this.navigateToBillingPortal(result.data.url)
        } else {
            await this.redirectToCheckout(result.data.id, result.data.stripePublicKey, result.data.stripeConnectedAccountId);
        }
    }

    async getStripeMember(businessId, temporaryToken, priceId, cancelUrl= null) {
        let result;
        let url = `/api/StripeMember/appWebView?businessId=${businessId}&temporaryToken=${temporaryToken}&priceId=${priceId}&returnUrl=${encodeURIComponent(window.location.href)}`;
        if(cancelUrl){
            url += `&cancelUrl=${encodeURIComponent(cancelUrl)}`;
        }
        try {
            result = await axios.get(url
                // , {
                // params: {
                //     businessId: businessId,
                //     temporaryToken: temporaryToken,
                //     returnUrl: encodeURIComponent(window.location.href)
                // }
            //}
            );
        } catch (e) {
            console.error("error");
            this.setState({error: true});
        }
        return result;
    }

    async redirectToCheckout(sessionId, stripePublicKey, stripeAccountId) {
        const options = {};
        if(stripeAccountId){
            options.stripeAccount = stripeAccountId;
        }
        const stripe = await loadStripe(stripePublicKey, options);
        await stripe.redirectToCheckout({
            sessionId: sessionId,
        })
    }

    navigateToBillingPortal(url) {
        if (window !== window.top) {
            console.log("iframe");
            try {
                console.log("Stripe URL:", url, 'Parent URL:', window.top.location.href);
                window.open(url, "_blank");
            } catch (error) {
                console.warn("Cannot access parent URL due to cross-origin restrictions:", error);
            }
        }
        window.location.href = url;
    }

    render() {
        return (
            <div>
                {this.state.error &&
                <div>Sorry, an error occured</div>
                }
                {!this.state.error &&
                <div className="loader"/>
                }
            </div>
        );
    }
}